<template>
    <div id="review">
     

    <form>
            
        <div class="title">
            <h3><span>{{user.hotel}}</span> {{lang.whatThink}}</h3>
            <RatingTotal :lang="lang" :max="5" :lists="userCheckList" :total="total"/>
        </div>

        <RatingList :lang="lang" :max="5" :lists="userCheckList" @ratings="userChecked" />

        <div class="selective-list">
            <p class="label">{{lang.goal_travel}}</p>
            <Tabs :lang="lang" 
                :selected="Object.keys(guestType).length>0 && guestType.id ? guestType.id:''" 
                :lists="getGuestType"
                 @changed="guestTypeChanged" />
            
        </div>

        <!-- {{ customItems }} -->

        <div class="selective-list" v-for="(custom, key) in customItems" :key="key">
            <p class="label">{{ custom.display }}</p>
        
           <div class="options-input">
             <Tabs :lang="lang" v-if="custom.type === 'radio'" 
                    :selected="custom.value.id"
                    :lists="custom.options"
                    @changed="customItemChange"
                />
                
                <input type="text" v-model="custom.value.text" v-show="custom.value.handWriting"/>
           </div>
        </div>

            <div class="user-inputs">
                <Textarea :lang="lang" :txt="textarea" @realtime="inputReview"/>
                <small>{{lang.review_notice}}</small>
                
            </div>
            <div class="user-img">
                <FileUpload :lang="lang" :user="user" @emitData="inputImages"/>
                
            </div>
            <div class="msg">
                <p>{{lang.mag_thank}}</p>
            </div>

          
    </form>

    <div class="footer">
        <Button :btn="buttons.submit" @btnClick="reviewSubmit" />
    </div>

        <Footer/>

      <!-- Modal -->
       
       <!-- <TextPls v-show="isPls" :btn="send.lang" :review="review.value" @plsBtn="submit" @closePls="isPls = false">
            <div class="plsIco">
                <img :src="require(`@/assets/image/ico_pls_${replaceReview(review.value).length === 0 ? 'no' : 'yes'}.svg`)">
            </div>
            <div class="plsMsg">
                <div class="plsMsgH">
                    {{$LANG.pls_MainMsg}}
                </div>
                <div>
                    {{$LANG.pls_Thank}}
                </div>
            </div>
            <Textarea :phValue="$LANG.pls_placeholder" :reviewVal="review.value" @input="inputContents"  class="plsTextArea"/>
        </TextPls> -->

        <Modal v-if="isModal" 
            :lang="lang" 
            :values="textarea"
            @realtime="inputReview"
            @close="modalClose"
            @modalInputs="newInputReview"
            />
  </div>
</template>

<script>



import Textarea from '@/components/forms/Textarea'
import Input from '@/components/forms/Input';
import Button from '@/components/forms/Button';
import FileUpload from '@/components/forms/FileUpload'

import Analytics from '@/common/analytics.js';
import { mapActions, mapGetters } from 'vuex';

import RatingList from '@/components/widget/RatingList'
import RatingTotal from '@/components/widget/RatingTotal'
import Tabs from '@/components/forms/Tabs'

import Modal from '@/components/modal/ReviewCheck'
import Footer from '@/components/layout/Footer'
 

export default {
    name: 'Review',
    props: ['user', 'lang'],
    components: {
        Textarea, Button, Input,
        RatingTotal, RatingList, Tabs,
        FileUpload,
        Modal,
        Footer

        
    },
    async created(){
        this.customItems = {...this.$store.getters['getCustomItems']};        
        this.gaevent('site-review', 'enter');
        this.userCheckList.forEach(x => {   
            x.value = 0
        });
    },
    data(){
        return {
            isLoading: true,
            isModal: false,
            gaevent(category, event) {
                Analytics.gtag('event', event,{'event_category' : category,});	
                // Analytics.gtag('event', event,{'event_category' : category,});	
            },

            buttons: {
                submit: {
                    label: this.lang.submit,
                    className: 'default'
                }
            },
            guestType: {},
            textarea: {
                value: '',
                placeholder: this.lang.textA_pHolder
            },
            images: [],
            total: {
                avg: (0).toPrecision(2),
                range: 0
            },
            
            customItemsObj: {}
        }
    },

    computed: {
        ...mapGetters(['getIsLoading', 'getReviewType', 'getCheckList', 'getGuestType']),
        customItems: {
            get: function(){
                return this.customItemsObj
            },
            set: function(payload){
                this.customItemsObj = {...payload};
            }
        },
        userCheckList: {
            get: function(){
                return this.getCheckList
            },
            set: function(payload){
                
                this.userCheckList.forEach(x => {
                    if(x.id === payload.type.id){
                        x.value = payload.value
                    }
                });
                this.checkTotal();

               
            }
        },
        getRatingTotal(){
            return this.total
        },

    },
    methods: {
        ...mapActions(['setIsLoading']),
        customItemChange(payload){
            const {id, key } = payload;
            this.customItemsObj[key].value = this.customItemsObj[key].value===id ? {...{}} : {...payload};


        },
        checkTotal(){
             let total = 0, count=0, avg = 0;
                this.userCheckList.forEach(x=>{
                    if(x.value>0){
                    total+=x.value;
                    ++count;
                    }
                });
                avg = (total/count).toPrecision(2);
                const value = total===0 ? 0 : Math.floor(avg)<1?1:Math.floor(avg);
                this.total ={ ... {
                    avg: total===0 ? (0).toPrecision(2):avg < 1 ? (1).toPrecision(2) : avg,
                    range: value
                }}
        },
        userChecked(payload){
            this.userCheckList = payload;
        },

        guestTypeChanged(payload){
            this.guestType = this.guestType === payload ? '':payload;
        },


        inputReview(payload){
            this.textarea.value = payload;
        },

        newInputReview(payload){

            this.textarea.value = payload.inputs;
            this.isModal = false;
            
            this.setIsLoading(true);
            
            const params = {
                key: this.user.k,
                rate: Number(this.total.avg),
                stayType: this.guestType.value?this.guestType.value:9,
            }
              const customArr = {};
            for (const key in this.customItems) {

                const { value: { id = '', text = '', itemValueKey = '' }, display = '' } = this.customItems[key]
                customArr[key] = {
                    value: text || (id === '3' ? '' : itemValueKey),
                    display: display || key.toUpperCase()
                }
            }
            if(Object.keys(customArr).length>0){
                params.custom = {...customArr}
            }


                    this.userCheckList.forEach(x=>{
                        params[x.id] = Number(x.value.toFixed(2))
                    });

                    if(this.images.length>0){
                        params.images = this.images;
                    }

            
                        if(this.textarea.value.length>0){
                            params.review = this.textarea.value.trim() ;
                        }

                        
                        
                        this.$store.dispatch('setReview', params).then(res=>{
                            this.setIsLoading(false);
                        }).catch(err=>{
                            this.setIsLoading(false);
                        })
                    

        },

        inputImages (payload) {
            
            this.images = payload.data;
            this.$store.dispatch('setIsLoading', false);
        },

        modalClose(){
            this.isModal = false;
        },

        reviewSubmit(){
            const customArr = {};
            for (const key in this.customItems) {
                
                const {value: { id = '', text = '', itemValueKey=''}, display = ''  } = this.customItems[key]
                customArr[key] = {
                    value: text || (id === '3' ? '' : itemValueKey),
                    display: display || key.toUpperCase()
                }   
            }
            
            this.setIsLoading(true);

            const count = this.userCheckList.filter(x=>{
                return x.value === 0
            }).length;
            

            if(count>0){
                alert(this.lang.msg_grade_none);
                this.setIsLoading(false);
            }else{
                const txtCount = this.textarea.value.replace(/ /gi, "").replace(/(?:\r\n|\r|\n)/g, '').length;
                
                
                    // alert('전송')
                    const params = {
                        key: this.user.k,
                        rate: Number(this.total.avg),
                        stayType: this.guestType.value?this.guestType.value:9,
                        
                    }
                    
                    if(Object.keys(customArr).length>0){
                        params.customArr = { ...customArr };
                    }
                    

                    this.userCheckList.forEach(x=>{
                        params[x.id] = Number(x.value.toFixed(2))
                    });

                    if(this.images.length>0){
                        params.images = this.images;
                    }

                    
                    
                    if(txtCount>4){
                        params.review = this.textarea.value.trim() ;
                        
                        this.$store.dispatch('setReview', params).then(res=>{

                            this.setIsLoading(false);
                        });
                        
                    }else{
                        this.setIsLoading(false);
                        this.isModal = true;
                    }

                   
                    


                
            }
        }
    }
}
</script>

<style lang="scss" scoped>

#review {
    

    form {
        padding: 24px;
        min-height: calc(100vh - 142px);
        .title{
            h3 {
                text-align: center;
                margin-bottom: 24px;
                span {
                    color: $color-point;
                }
            }
        }
        div {
            &.selective-list{
                margin-bottom: 24px;
            }
            
            &.user-inputs{
                small{
                    color: $color-sub-txt;
                }
                margin-bottom: 24px;
            }
            
            &.user-img{
                small{
                    color: $color-sub-txt;
                }
            }
            &.msg{
                margin: 24px 0;
                text-align: center;
                *{
                    color: $color-point;
                }
            }
            
        }
    }

    .seleted-option{
        @include flexs(center, flex-start, unset, wrap);
        input{
            margin-top: 4px;
        }
    }

    .footer {
        height: 56px;
        // position: fixed;
        // bottom: 0;
        // left: 0;
        // right: 0;

        >button {
            width: 100%;
            height: 100%;
            border-radius: 0;
            font-size: 1.2em;
        }
    }
}

</style>